/**
 * crypto.randomUUID icin guvenli fallback (Sentry JAVASCRIPT-REACT-10/12, issue #681).
 *
 * Bazi eski tarayicilarda veya guvenli olmayan baglamlarda
 * (non-HTTPS/localhost disi origin) globalThis.crypto.randomUUID tanimsiz
 * olabilir. Bu helper sirasiyla dener:
 *   1. globalThis.crypto.randomUUID() (native, en hizli/dogru)
 *   2. globalThis.crypto.getRandomValues() tabanli RFC4122 v4 uretimi
 *   3. Math.random() tabanli son care fallback (crypto hic yoksa)
 */
export function safeRandomUUID(): string {
  const cryptoObj = globalThis.crypto as Crypto | undefined

  if (cryptoObj && typeof cryptoObj.randomUUID === 'function') {
    return cryptoObj.randomUUID()
  }

  if (cryptoObj && typeof cryptoObj.getRandomValues === 'function') {
    const bytes = new Uint8Array(16)
    cryptoObj.getRandomValues(bytes)
    // RFC4122 v4: version ve variant bitlerini ayarla
    bytes[6] = (bytes[6] & 0x0f) | 0x40
    bytes[8] = (bytes[8] & 0x3f) | 0x80
    const hex = Array.from(bytes, (b) => b.toString(16).padStart(2, '0'))
    return `${hex.slice(0, 4).join('')}-${hex.slice(4, 6).join('')}-${hex.slice(6, 8).join('')}-${hex.slice(8, 10).join('')}-${hex.slice(10, 16).join('')}`
  }

  // Son care: crypto hic yok (cok eski/kisitli ortam)
  let uuid = ''
  for (let i = 0; i < 36; i += 1) {
    if (i === 8 || i === 13 || i === 18 || i === 23) {
      uuid += '-'
    } else if (i === 14) {
      uuid += '4'
    } else if (i === 19) {
      uuid += ((Math.random() * 4) | 8).toString(16)
    } else {
      uuid += Math.floor(Math.random() * 16).toString(16)
    }
  }
  return uuid
}
